import classNames from "classnames";
import { useRef, useState } from "react";

// Custom SVG icons replacing MUI icons
const PlusIcon = ({ className }) => (
    <svg className={className} width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <line x1="12" y1="5" x2="12" y2="19" />
        <line x1="5" y1="12" x2="19" y2="12" />
    </svg>
);

const CameraIcon = ({ className }) => (
    <svg className={className} width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" />
        <circle cx="12" cy="13" r="4" />
    </svg>
);

function ProfileImage({ image, onChange }) {
    const fileInputRef = useRef();
    const [highlight, setHighlight] = useState(false);
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [file, setFile] = useState(null);

    const handleDragEnter = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setHighlight(true);
    };
    const handleDragLeave = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setHighlight(false);
    };
    const handleDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };
    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setHighlight(false);
        const file = e.dataTransfer.files[0];
        setFile(file);
        onChange(file);
    };
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        setFile(file);
        onChange(file);
    };
    const handleRemoveFile = () => {
        setFile(null);
    };

    const imageUrl = file ? URL.createObjectURL(file) : image;

    return (
        <>
            <div
                className={classNames(
                    "relative group flex items-center justify-center cursor-pointer rounded-full transition-all duration-300",
                    {
                        "ring-4 ring-blue-400/50 scale-105": highlight,
                        "ring-4 ring-rose-400/50": error,
                        "ring-2 ring-dashed ring-slate-200 hover:ring-blue-300": !imageUrl && !highlight && !error,
                    },
                )}
                onDragEnter={handleDragEnter}
                onDragLeave={handleDragLeave}
                onDragOver={handleDragOver}
                onDrop={handleDrop}
                onClick={() => fileInputRef.current.click()}
                style={{ width: "130px", height: "130px" }}
            >
                {imageUrl ? (
                    <>
                        <img
                            src={imageUrl}
                            alt="avatar"
                            className="rounded-full object-cover shadow-lg shadow-slate-200/50 group-hover:shadow-xl group-hover:shadow-blue-200/30 transition-all duration-300"
                            style={{ width: "130px", height: "130px" }}
                        />
                        {/* Edit overlay on hover */}
                        <div className="absolute inset-0 rounded-full bg-black/0 group-hover:bg-black/20 transition-all duration-300 flex items-center justify-center">
                            <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                                <CameraIcon className="text-white w-8 h-8" />
                            </div>
                        </div>
                        {/* Blue camera badge */}
                        <div className="absolute bottom-1 right-1 w-9 h-9 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full flex items-center justify-center shadow-lg shadow-blue-500/30 border-3 border-white group-hover:scale-110 transition-transform duration-200">
                            <CameraIcon className="text-white" />
                        </div>
                    </>
                ) : (
                    <div className="flex flex-col items-center justify-center h-[130px] bg-slate-50 rounded-full hover:bg-blue-50 transition-colors duration-200" style={{ width: "130px" }}>
                        <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center mb-2 group-hover:bg-blue-200 transition-colors duration-200">
                            <PlusIcon className="text-blue-500" />
                        </div>
                        <p className="text-xs font-medium text-slate-400 group-hover:text-blue-500 transition-colors duration-200">Загрузить</p>
                    </div>
                )}
            </div>
            <input
                ref={fileInputRef}
                type="file"
                id="file"
                accept="image/*"
                className="hidden"
                onChange={handleFileChange}
            />
        </>
    );
}

export default ProfileImage;